<div class="flex flex-column align-items-center justify-content-center w-full h-full">
  <mat-icon class="material-symbols-outlined text-gray-400 icon-6xl">map</mat-icon>
  <span class="font-light text-gray-700 text-sm">Seleziona sulla mappa</span>
</div>
